import * as React from 'react';

import "./PieChart.scss"
import { VictoryPie } from 'victory';

interface Props {
    data:PieChartRow[]  
    height:number
}
interface State {
  percentage:number
    label:string 
    showInfo:boolean
}

export interface PieChartRow {
  label:string 
  value:number
  color:string
}

export class PieChart extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);
    this.state = {showInfo:true, label:"", percentage:0}
  }

  render() {
      const {percentage, label, showInfo} = this.state; 
      let rows:any =  []
      let colors:any = []
      let total:any = 0;
      if (this.props.data) {
        for (let i = 0; i < this.props.data.length; i++) {
          const element = this.props.data[i];
          total += element.value;
          rows.push({x:element.label, y:element.value})
          colors.push(element.color)
        }
        for (let i = 0; i < rows.length; i++) {
          rows[i].y = Math.round((rows[i].y / total) * 1000) / 10;
        }
      }
    const infoStyle= (showInfo)? { opacity:1 } : {opacity:0}
      return <div className={"PieChart"}>
    <div className="pieChatInfo">
    <div className="percentage" style={infoStyle}>{(percentage)? Math.round(percentage * 10) / 10  + "%": ""}</div>
    <div className="label" style={infoStyle}>{label}</div>
    </div>
    
<VictoryPie
  data={rows}
animate={{ duration: 2000, easing: "bounce" }}


  height={this.props.height}
  width={this.props.height}
  colorScale={colors}

  innerRadius={({ datum }) => (this.props.height/2) - 20}
  labelRadius={({ innerRadius }) => 100}
  radius={this.props.height/2}
  style={{ labels: {display:"none"} }}

  

  events={
    [{
        target: "data",
        eventHandlers: {
          onMouseOver: () =>  [ {target: "data", mutation: (props) => {   this.setState({label:props.datum.x, percentage:props.datum.y, showInfo:true}); return { innerRadius:(this.props.height/2) - 30} }}],
          // onMouseOver: () =>  [ {target: "data", mutation: (props) => {  this.setState({label:props.datum.x, percentage:props.datum.y}); return { innerRadius:80, radius:130, style:{fill:"#00CABE"}} }}],
          onMouseOut: () =>  [ {target: "data", mutation: (props) => {   this.setState({showInfo:false}); return {} }}],
         }} ]  
    


        }


/>

    </div>
  }
};

  
